import { toast } from "react-toastify";
import Page from "../../../../components/Layout/Page";
import { useIsMobile } from "../../../../helpers/ui";
import { colors } from "../../../../styles";
import { DesktopHeader, MobileHeader } from "../Account/components";
import {
  employeeAccountPath,
  employeeRequestCardPath,
  employeeRequestCardSuccessPath,
  employeeSettingsPath,
} from "../../../../routes/paths";
import HeaderBreadcrumbs from "../../../../components/HeaderBreadcrumbs";
import T from "../../../../components/Typography";
import ResponsePageContent from "../../../../components/Layout/ResponsivePageContent";
import { useNavigate } from "react-router-dom";
import useGetAccount from "../../../../hooks/queries/employee/useGetAccount";
import Loader from "../../../../components/Loader";
import { showDebitCardFeature } from "../../../../helpers/debitcard";
import ErrorPage from "../../../../components/ErrorPage";
import { OrderNewCardContents } from "../DebitCardOrderNewCard/OrderNewCard";
import useGetMailingAddress from "../../../../hooks/queries/employee/useGetMailingAddress";
import useOrderNewCard from "../../../../hooks/mutations/employee/useOrderNewCard";

const RequestCard = () => {
  const { data, status: accountStatus } = useGetAccount();
  const { data: addressData, status: mailingAddressStatus } =
    useGetMailingAddress();
  const { mutateAsync: orderNewCard, status: orderNewCardStatus } =
    useOrderNewCard();
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const title = "Request a Debit Card";
  const subtitle = "Make sure everything looks good";
  const breadcrumbs = ["Profile & Settings", title];

  if (accountStatus === "loading" || mailingAddressStatus === "loading")
    return <Loader />;
  if (orderNewCardStatus === "loading")
    return <Loader text="Ordering card..." />;
  if (accountStatus === "error" || mailingAddressStatus === "error")
    return <ErrorPage />;

  const doBack = () => {
    navigate(employeeSettingsPath);
  };

  const handleSave = async () => {
    if (!addressData.shipping_address) {
      toast.error("Please enter a mailing address.");
    }
    const response = await orderNewCard();
    if (response.status && response.status === "success") {
      navigate(employeeRequestCardSuccessPath);
    }
  };

  const renderFeatureDisabled = () => {
    return (
      <div>
        <T variant="lgReg" color={colors.red}>
          Debit cards are not enabled for your program.
        </T>
      </div>
    );
  };

  const featureEnabled = showDebitCardFeature(
    data.challenger_saving.debit_card
  );

  return (
    <Page>
      {isMobile ? (
        <MobileHeader
          title={title}
          showBack
          showClose
          handleBack={doBack}
          closeRoutePath={employeeAccountPath}
        />
      ) : (
        <DesktopHeader>
          <HeaderBreadcrumbs breadcrumbs={breadcrumbs} handleBack={doBack} />
        </DesktopHeader>
      )}
      <ResponsePageContent title={title} subtitle={subtitle}>
        {featureEnabled ? (
          <OrderNewCardContents
            addressData={addressData}
            handleSave={handleSave}
            navigateBackPath={employeeRequestCardPath}
            agreeText="I reviewed my mailing address and I understand that this card is meant for unplanned and emergency expenses"
          />
        ) : (
          renderFeatureDisabled()
        )}
      </ResponsePageContent>
    </Page>
  );
};

export default RequestCard;
